import cs from 'classnames';
import React from 'react';
import { ReactBootstrapModal } from 'shared/components/ReactModal';
import { useProtectionPlanInformationQuery } from '../generated.graphql';


interface Props {
  portalSlug: string;
  className?: string;
  children?: React.ReactChild;
}


const ProtectionPlanInformationModalContent = (props: Props) => {
  const [result,] = useProtectionPlanInformationQuery({variables: {portalSlug: props.portalSlug}, requestPolicy: "cache-first"})
  return (
    <div 
      className="py-3"
      dangerouslySetInnerHTML={{
        __html: result.data?.portal?.policies.protectionPlan?.content.replace(/href/g, "target='_blank' href") || "<div>Loading...</div>"
      }}
    />
  )
}


export const ProtectionPlanInformationModalButton = (props: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <>
       <button type="button" className={cs(props.className ?? "btn btn-link px-0")} onClick={() => setIsOpen(true)}>
        {props.children ?? 'Protection Plan Guide'}
      </button>
      <ReactBootstrapModal
        title="Protection Plan Guide"
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
      >
        <ProtectionPlanInformationModalContent portalSlug={props.portalSlug} />
      </ReactBootstrapModal>
    </>
  )
}
